module.exports = __webpack_public_path__ + "static/media/d2ru.61f46791.pdf";